import { HookEditorDockingPanelContent } from "./content/hookEditorDockingPanelContent";

import { DockingPanel } from "./dockingPanel";

export class HookEditorDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement) {
        this.visible = false;

        const component = <HookEditorDockingPanelContent />;

        this.panel = new DockingPanel(container, "dextall-studio-hook-editor", "Hook properties", component, {
            style: {
                width: "360px",
                height: "370px",
                minWidth: "360px",
                minHeight: "370px",
                resize: "both",
                left: "2px",
                top: "2px",
            },
        });
        this.panel.addVisibilityListener((x: boolean) => this.visible = x);
    }

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }

        this.visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
    }
}
